import PropTypes from "prop-types";
import dayjs from "dayjs";
import Grid from "@mui/material/Unstable_Grid2";
import { Typography, Link } from "@mui/material";

import { initLocalization } from "../../../utils/helpers";
import { viewMappingDetailsMetadataStrings } from "./locale";

import { MAPPING_KEYS_DATE_FORMAT } from "../../../constants";

export const ViewMappingDetailsMetadata = ({ item }) => {
  initLocalization(viewMappingDetailsMetadataStrings);

  return (
    <Grid
      container
      flexDirection="column"
      flex="2"
      justifyContent="center"
      gap="0.625rem"
      padding="2rem"
    >
      <Typography sx={{ fontWeight: "bold" }}>
        {viewMappingDetailsMetadataStrings.date}
      </Typography>
      <Typography>
        {dayjs(item.creativeDetails.date).format(MAPPING_KEYS_DATE_FORMAT)}
      </Typography>
      <Typography sx={{ fontWeight: "bold" }}>
        {viewMappingDetailsMetadataStrings.id}
      </Typography>
      <Typography>{item.creativeDetails.creativeId}</Typography>
      <Typography sx={{ fontWeight: "bold" }}>
        {viewMappingDetailsMetadataStrings.sponsoredType}
      </Typography>
      <Typography>{item.creativeDetails.sponsoredType}</Typography>
      <Typography sx={{ fontWeight: "bold" }}>
        {viewMappingDetailsMetadataStrings.advertiserName}
      </Typography>
      <Typography>{item.creativeDetails.advertiserName}</Typography>
      <Typography sx={{ fontWeight: "bold" }}>
        {viewMappingDetailsMetadataStrings.advertiserPaid}
      </Typography>
      <Typography>{item.creativeDetails.advertiserPaid}</Typography>
      <Typography sx={{ fontWeight: "bold" }}>
        {viewMappingDetailsMetadataStrings.link}
      </Typography>
      <Typography>
        <Link href={item.creativeDetails.creativeLink} target="_blank">
          {viewMappingDetailsMetadataStrings.link}
        </Link>
      </Typography>
      <Typography sx={{ fontWeight: "bold" }}>
        {viewMappingDetailsMetadataStrings.title}
      </Typography>
      <Typography>{item.creativeDetails.title}</Typography>
    </Grid>
  );
};

ViewMappingDetailsMetadata.propTypes = {
  item: PropTypes.object.isRequired,
};
